<script lang="ts">
  import type {
    IFormSeanEllisNode,
    PartialNode,
  } from "@shared/common/node/type";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";

  import { generateFormDataName } from "@shared/common/utils/form";
  import FormChoiceOption from "./form/form-choice-option.svelte";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormSeanEllisNode>;

  $: name = generateFormDataName(node);
</script>

<div
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
>
  <FormLabel label={node.label} required={node.required} />

  <div class="form-option-container">
    {#each node.items || [] as item}
      <FormChoiceOption
        {name}
        id={item.id}
        label={item.label}
        required={node.required}
        type={node.choiceType}
      />
    {/each}
  </div>
</div>

<style>
  .form-option-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: calc(var(--cb-form-font-size) * 0.5);
    gap: calc(var(--cb-form-font-size) * 0.5);
  }
</style>
